export const N64 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Product Sales by Channel (PESO)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Principal Code',
                        "columnName": 'DistributorCode',
                        "width": '150px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales(Value)',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'LYSales',
                        "columnName": 'LYSales(Value)',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth(Value)',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "percent": true
                    }

                ],
                "title": 'DistributorCode',
                "endpoint": "N64",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" },
                    { "key": "RegionCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "DistributorCode",
                        "visuals": [
                            {
                                "title": "Region",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "Region",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Region',
                                                            "columnName": 'RegionCode',
                                                            "width": '100px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LYSales',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'RegionCode',
                                                    "endpoint": "N64.1",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "DistributorCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" },
                                                        { "key": "RegionCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {
                                                            "selectedValueColumn": "DistributorCodeRegionCode",
                                                            "selectedTitle": "Product",
                                                            "visual": [
                                                                {
                                                                    "columns": 12,
                                                                    "rows": 2,
                                                                    "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": "colorTheme1",
                                                                        "title": "Product",
                                                                        "binding": {
                                                                            "data": {
                                                                                "columns": [
                                                                                    {
                                                                                        "name": 'Item Name',
                                                                                        "columnName": 'ItemName',
                                                                                        "width": '200px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false
                                                                                    },
                                                                                    {
                                                                                        "name": 'Sales (PESO)',
                                                                                        "columnName": 'ActualSales(Value)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LYSales (PESO)',
                                                                                        "columnName": 'LYSales(Value)',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": '% Growth (PESO)',
                                                                                        "columnName": 'Growth(Value)',
                                                                                        "width": '170px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'Sales (UNIT)',
                                                                                        "columnName": 'ActualSales(Qty)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LYSales (UNIT)',
                                                                                        "columnName": 'LYSales(Qty)',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": '% Growth (UNIT)',
                                                                                        "columnName": 'Growth(Qty)',
                                                                                        "width": '170px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    }
                                                                                ],
                                                                                "title": 'ItemName',
                                                                                "endpoint": "N64.4",
                                                                                "parameters": [
                                                                                    { "key": "FromMonth", "value": "2024" },
                                                                                    { "key": "FromYear", "value": "1" },
                                                                                    { "key": "ToMonth", "value": "2024" },
                                                                                    { "key": "ToYear", "value": "1" },
                                                                                    { "key": "ConfigTypeCode", "value": "" },
                                                                                    { "key": "DistributorCodeRegionCode", "value": "" }
                                                                                ]
                                                                            },
                                                                            "context": {
                                                                                "point": {
                                                                                    "onClick": {

                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            },
                            {
                                "title": "District",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "District",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'District Manager Name',
                                                            "columnName": 'DistrictManagerName',
                                                            "width": '250px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'District Name',
                                                            "columnName": 'DistrictName',
                                                            "width": '200px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Region',
                                                            "columnName": 'RegionCode',
                                                            "width": '100px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LYSales',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'DistrictManagerName',
                                                    "endpoint": "N64.2",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "DistributorCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" },
                                                        { "key": "RegionCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {
                                                            "selectedValueColumn": "DistributorCodeRegionDistrict",
                                                            "selectedTitle": "Product",
                                                            "visual": [
                                                                {
                                                                    "columns": 12,
                                                                    "rows": 2,
                                                                    "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": "colorTheme1",
                                                                        "title": "Product",
                                                                        "binding": {
                                                                            "data": {
                                                                                "columns": [
                                                                                    {
                                                                                        "name": 'Item Name',
                                                                                        "columnName": 'ItemName',
                                                                                        "width": '200px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false
                                                                                    },
                                                                                    {
                                                                                        "name": 'Sales (PESO)',
                                                                                        "columnName": 'ActualSales(Value)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LYSales (PESO)',
                                                                                        "columnName": 'LYSales(Value)',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": '% Growth (PESO)',
                                                                                        "columnName": 'Growth(Value)',
                                                                                        "width": '170px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'Sales (UNIT)',
                                                                                        "columnName": 'ActualSales(Qty)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LYSales (UNIT)',
                                                                                        "columnName": 'LYSales(Qty)',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": '% Growth (UNIT)',
                                                                                        "columnName": 'Growth(Qty)',
                                                                                        "width": '170px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    }
                                                                                ],
                                                                                "title": 'ItemName',
                                                                                "endpoint": "N64.5",
                                                                                "parameters": [
                                                                                    { "key": "FromMonth", "value": "2024" },
                                                                                    { "key": "FromYear", "value": "1" },
                                                                                    { "key": "ToMonth", "value": "2024" },
                                                                                    { "key": "ToYear", "value": "1" },
                                                                                    { "key": "ConfigTypeCode", "value": "" },
                                                                                    { "key": "DistributorCodeRegionDistrict", "value": "" }
                                                                                ]
                                                                            },
                                                                            "context": {
                                                                                "point": {
                                                                                    "onClick": {

                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            },
                            {
                                "title": "PMR",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "PMR",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'PMR Code',
                                                            "columnName": 'AgentCode',
                                                            "width": '150px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Employee Code',
                                                            "columnName": 'EmployeeCode',
                                                            "width": '150px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'PMR Name',
                                                            "columnName": 'AgentName',
                                                            "width": '250px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Area Name',
                                                            "columnName": 'TerritoryName',
                                                            "width": '300px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'District Name',
                                                            "columnName": 'DistrictName',
                                                            "width": '200px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Region',
                                                            "columnName": 'RegionCode',
                                                            "width": '100px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LYSales',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'AgentName',
                                                    "endpoint": "N64.3",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "DistributorCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" },
                                                        { "key": "RegionCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {
                                                            "selectedValueColumn": "DistributorCodeRegionDistrictAgent",
                                                            "selectedTitle": "Product",
                                                            "visual": [
                                                                {
                                                                    "columns": 12,
                                                                    "rows": 2,
                                                                    "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": "colorTheme1",
                                                                        "title": "Product",
                                                                        "binding": {
                                                                            "data": {
                                                                                "columns": [
                                                                                    {
                                                                                        "name": 'Item Name',
                                                                                        "columnName": 'ItemName',
                                                                                        "width": '200px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false
                                                                                    },
                                                                                    {
                                                                                        "name": 'Sales (PESO)',
                                                                                        "columnName": 'ActualSales(Value)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LYSales (PESO)',
                                                                                        "columnName": 'LYSales(Value)',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": '% Growth (PESO)',
                                                                                        "columnName": 'Growth(Value)',
                                                                                        "width": '170px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'Sales (UNIT)',
                                                                                        "columnName": 'ActualSales(Qty)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LYSales (UNIT)',
                                                                                        "columnName": 'LYSales(Qty)',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": '% Growth (UNIT)',
                                                                                        "columnName": 'Growth(Qty)',
                                                                                        "width": '170px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    }
                                                                                ],
                                                                                "title": 'ItemName',
                                                                                "endpoint": "N64.6",
                                                                                "parameters": [
                                                                                    { "key": "FromMonth", "value": "2024" },
                                                                                    { "key": "FromYear", "value": "1" },
                                                                                    { "key": "ToMonth", "value": "2024" },
                                                                                    { "key": "ToYear", "value": "1" },
                                                                                    { "key": "ConfigTypeCode", "value": "" },
                                                                                    { "key": "DistributorCodeRegionDistrictAgent", "value": "" }
                                                                                ]
                                                                            },
                                                                            "context": {
                                                                                "point": {
                                                                                    "onClick": {

                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }
            }
        }
    }
}